import { createFileRoute } from "@tanstack/react-router";
import { SettingsForm } from "@/components/settings/settings-form";

export const Route = createFileRoute("/_app/painel/configuracoes")({
	component: SettingsPage,
});

function SettingsPage() {
	return (
		<div className="flex flex-col w-full px-4 lg:px-8">
			<SettingsForm />
		</div>
	);
}
